import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Price Tags"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-price-tags',
    templateUrl: './icon-price-tags.component.html',
    styleUrls: ['./icon-price-tags.component.scss'],
    standalone: false
})
export class IconPriceTagsComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
